<template>
    <div class="card card-blue">
        <div class="card-header">
            <h4 class="card-title">Edit {{challan.number}}
                <span class="label font-weight-bold"
                      :class="{
                                            'label-info' : challan.status === 'DRAFT' ,
                                            'label-success' : challan.status === 'CONFIRMED' ,
                                            'label-inverse' : challan.status === 'INVOICED'
                                            }">
                    <template v-if="challan.status === 'DRAFT'">Draft</template>
                    <template v-if="challan.status === 'CONFIRMED'">Confirmed</template>
                    <template v-if="challan.status === 'INVOICED'">Invoiced</template>
                </span>
            </h4>
        </div>
        <form @submit.prevent="validate">
            <div class="card-body">
                <div class="form-group row">
                    <label class="col-sm-2 text-right control-label col-form-label">Warehouse :</label>
                    <div class="col-sm-8">
                        <input v-model="warehouse.name"
                               class="form-control"
                               disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 text-right control-label col-form-label">Buyer :</label>
                    <div class="col-sm-8">
                        <multiselect
                                :class="{'is-invalid': submitted && errors.has('buyer')}"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :hide-selected="true"
                                :internal-search="false"
                                :loading="isLoading"
                                :options="partners"
                                :searchable="true"
                                :show-no-results="false"
                                @search-change="searchPartners"
                                class="form-control multiselect-sm"
                                data-vv-as="Buyer"
                                label="buyer"
                                name="buyer"
                                open-direction="bottom"
                                placeholder="Search Buyer"
                                track-by="id"
                                v-model="challan.buyer"
                                v-validate="'required'">
                            <template slot="singleLabel" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc">
                                        {{ props.option.biz_name }}
                                    </div>
                                </div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc" v-if="props.option">
                                        <h5>{{ props.option.biz_name }}</h5>
                                    </div>
                                    <div class="option__desc" v-else>
                                        <h5>Add New</h5>
                                    </div>
                                </div>
                            </template>
                        </multiselect>
                        <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('buyer')">{{ errors.first('buyer') }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 text-right control-label col-form-label">Reference :</label>
                    <div class="col-sm-8">
                        <input :class="{'is-invalid': submitted && errors.has('ref')}" id="ref2"
                               name="ref"
                               class="form-control"
                               data-vv-as="Challan Reference"
                               placeholder="Reference"
                               type="text"
                               v-model="challan.ref"
                               v-validate="'required'">
                        <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('ref')">{{ errors.first('ref') }}</div>
                    </div>
                </div>
                <div class="form-group row" v-for=" (item,i) in challan.items">
                    <label class="col-sm-2 text-right control-label col-form-label">Item {{i+1}} :</label>
                    <div class="col-sm-4">
                        <multiselect :class="{'is-invalid': submitted && errors.has('goodsservice'+i)}"
                                     :clear-on-select="false"
                                     :close-on-select="true"
                                     :hide-selected="true"
                                     :internal-search="false"
                                     :limit="3"
                                     :max-height="600"
                                     :options="invGoods"
                                     :options-limit="300"
                                     :searchable="true"
                                     :show-no-results="false"
                                     @input="setUnit(item)"
                                     @search-change="filterGoods"
                                     class="form-control multiselect-sm"
                                     data-vv-as="Good"
                                     :id="'goodsservice3'+i"
                                     label="goodsservice"
                                     :name="'goodsservice'+i"
                                     open-direction="bottom"
                                     placeholder="Search Goods/Service"
                                     selectLabel=""
                                     v-model="item.good"
                                     track-by="id"
                                     v-validate="'required'">
                            <template slot="singleLabel" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                        {{ props.option.name }} - {{ props.option.variety }}
                                    </div>
                                </div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc" v-if="props.option">
                                        <h5>{{ props.option.name }}</h5>
                                        <h6>{{ props.option.variety }}</h6>
                                        Available Quantity {{ props.option.quantity }}{{props.option.unit}}
                                    </div>
                                    <div class="option__desc" v-else>
                                        <h5>Add New</h5>
                                    </div>
                                </div>
                            </template>
                        </multiselect>
                        <div class="invalid-feedback" v-if="submitted && errors.has('goodsservice'+i)">{{ errors.first('goodsservice'+i) }}</div>
                    </div>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <input :class="{'is-invalid': submitted && errors.has('quantity'+i)}"
                                   :id="'quantity3'+i"
                                   :name="'quantity'+i"
                                   class="form-control"
                                   data-vv-as="Quantity"
                                   placeholder="Quantity"
                                   type="number"
                                   step="any"
                                   v-model="item.quantity"
                                   v-validate="'required',`between:0,${item.limit}`">
                            <input :class="{'is-invalid': submitted && errors.has('quantity'+i)}"
                                   class="form-control" disabled style="max-width: 40px"
                                   :value="item.unit">
                        </div>
                        <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('quantity'+i)">{{ errors.first('quantity'+i) }}</div>
                    </div>
                    <div class="col-sm-2">
                        <button type="button" class="btn btn-success mr-2" title="Add More Item" v-if="i===challan.items.length-1" @click="addItem">
                            <i class="fa fa-plus"/>
                        </button>
                        <button type="button" class="btn btn-danger" title="Remove This Item" v-if="challan.items.length != 1" @click="removeItem(i)">
                            <i class="fa fa-minus"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <div class="button-group">
                    <button class="btn btn-success" type="submit">Confirm</button>
                    <button class="btn btn-secondary" type="button" @click="reset">Reset</button>
                    <router-link :to="{ name: 'challans' }" class="btn btn-outline-secondary">Back</router-link>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Multiselect from "vue-multiselect";

    export default {
        name: "Edit",
        props: ["challanid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect},
        data() {
            return {
                isLoading: false,
                submitted: false,
                warehouse: {},
                bkp: {},
                challan: {
                    items: []
                },
                invGoods: [],
                partners: []
            }
        },
        mounted() {
            this.getChallan();
        },
        methods: {
            async getChallan() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get(`/express/${this.currentOrg.express_id}/challans/${this.challanid}`);
                    this.bkp   = data;
                    await this.getWarehouse(data.items[0].express_warehouse_id);
                    this.reset();
                } catch(e) {
                    console.error(e);
                    this.$toastr('error', 'Challan fetch failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getWarehouse(id) {
                let {data}     = await this.$http.get(`/express/${this.currentOrg.express_id}/inventory/warehouses/${id}`);
                this.warehouse = data;
                for(let i = 0; i < this.warehouse.inventory.length; i++) {
                    let goods = _.filter(this.bkp.items, (itm) => {
                        return itm.express_goods_services_id === this.warehouse.inventory[i].id
                    });

                    if(goods.length > 0) {
                        this.warehouse.inventory[i].quantity = Number(this.warehouse.inventory[i].quantity) + Number(goods[0].quantity);
                    }
                }
            },
            async validate() {
                this.submitted = true;
                let valid      = await this.$validator.validate();

                if(valid) {
                    this.update();
                }
            },
            async update() {
                try {
                    $(".preloader").fadeIn();

                    let payload = {
                        buyerid: this.challan.buyer.partner_id,
                        warehouseid: this.warehouse.id,
                        items: [],
                        ref: this.challan.ref
                    };

                    this.challan.items.forEach(item => {
                        payload.items.push({
                            express_goods_services_id: item.good.id,
                            quantity: item.quantity
                        });
                    });

                    let {data} = await this.$http.post(`/express/${this.currentOrg.express_id}/challans/${this.challanid}`, payload);
                    this.$toastr('success', 'Challan updated', 'Success');
                    this.$router.push({name: 'viewchallan', params: {challanid: this.challanid}});
                } catch(e) {
                    console.error(e);
                    this.$toastr('error', 'Challan update failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async searchWareHouses(search) {
                let {data}      = await this.$http
                .get(`/express/${this.currentOrg.express_id}/inventory/warehouses`, {
                    params: {
                        search
                    }
                });
                this.warehouses = data.warehouses;
            },
            filterGoods(searchtxt) {
                this.invGoods = _.filter(this.warehouse.inventory, (inv) => {
                    return inv.name.indexOf(searchtxt) !== -1;
                });
            },
            addItem() {
                this.challan.items.push({
                    good: null,
                    quantity: null,
                    unit: null,
                    limit: 0
                });
            },
            removeItem(i) {
                this.challan.items.splice(i, 1);
            },
            setUnit(item) {
                if(item.good) {
                    let goods = _.filter(this.challan.items, (_item) => {
                        return _item.good.id === item.good.id;
                    });
                    if(goods.length === 1) {
                        item.unit  = item.good.unit;
                        item.limit = Number(item.good.quantity);
                    } else {
                        this.$toastr('warning', 'Item already selected', 'Warning!');
                        item.good = null;
                    }
                }
            },
            reset() {
                this.submitted = false;

                this.challan = {
                    buyer: {
                        biz_name: this.bkp.buyer,
                        partner_id: this.bkp.buyer_id,
                    },
                    number: this.bkp.number,
                    status: this.bkp.status,
                    ref: this.bkp.reference,
                    items: []
                }

                this.bkp.items.forEach(item => {
                    let good = _.filter(this.warehouse.inventory, (good) => {
                        return good.id === item.express_goods_services_id
                    });

                    good = good[0];

                    this.challan.items.push({
                        good: good,
                        quantity: item.quantity,
                        unit: item.symbol,
                        limit: good.quantity
                    });
                });
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/partner/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners  = reply.data;
                    this.isLoading = false;
                } catch(e) {
                    console.log(e);
                }
            },
        }
    }
</script>

<style scoped>

</style>